import { IWizRoute } from '@wizeoo/akm-component-lib';

import { AuthGuard } from './authentication.guard';
import { ContextGuard } from './context.guard';
import { NavigationCheckGuard } from './navigation-check.guard';
import { PermissionCheckGuard } from './permission.guard';
import { FallbackView } from '../../views/fallback/fallback.view';
import { RootView } from '../../views/root/root.view';
import { InitView } from 'src/app/views/main/init.view';
import { AddView } from 'src/app/views/add/add.view';
import { ListView } from 'src/app/views/list/list.view';
import { LogView } from 'src/app/views/log/log.view';
import { GatlingView } from 'src/app/views/gatling/gatling.view';
import { ThumbView } from 'src/app/views/thumb/thumb.view';


/**
 * Les guards des enfants pour les vues principales en dehors de la fallback
 */
const childrenGuards: IWizRoute = { canActivate: [AuthGuard, PermissionCheckGuard, NavigationCheckGuard] };

/**
 * gestion des emplacements "navigables", des containers de fonctions,
 * des noms de vues et des boutons d'action
 */
export class RouteEngine {

  // les couleurs de base pour les vues admin
  public static TAB_COLOR_BASIC_TOOL: string = '#502b7a';
  public static TAB_COLOR_DARK_VISION: string = '#F58022';
  public static TAB_COLOR_BASIC_VISION: string = '#D7D7D7';

  public static ADD_VIEW: string = 'add'; // ajout d'un sourcing
  public static INIT_VIEW: string = 'home'; // vue de démarrage, mode thumb
  public static LIST_VIEW: string = 'list'; // mode liste
  public static FALLBACK_VIEW: string = 'context'; // vue de fallback en cas de contexte incohérent
  public static QUESTIONS_VIEW: string = 'questions'; // construction des questions
  public static MATCH_VIEW: string = 'match'; // match
  public static VISION_VIEW: string = 'init'; // vue de démarrage avec chargement du contexte
  public static NEWTAB_VIEW: string = 'newtab'; // vue d'ajout de vue (sans chargement du contexte)
  public static USER_TAB_VIEW: string = 'user-tab-view'; // vue pour les tabs custom du user
  public static USER_VIEW: string = 'user-view'; // vue de création et configuration des users
  public static DASHBOARD_DATA_VIEW: string = 'dashboard-data';
  public static LOG_VIEW: string = 'log'; // logs
  public static GATLING_VIEW: string = 'gatling'; // mode mitraillette
  public static THUMB_VIEW: string = 'thumb'; // vue thumb
  /**
   * construction de l'arbre de navigation statique
   * ATTENTION : le path doit être UNIQUE pour permettre une navigation sans FullPath
   */
  public static getRouteDefinition(): IWizRoute[] {
    const routes: IWizRoute[] = [
      {
        path: '',
        component: RootView,
        canActivate: [AuthGuard, ContextGuard],
        resolve: { ctx: ContextGuard },
        children: [
 
          // vue de démarrage pour chargement du contexte (home)
          { 
            path: RouteEngine.ADD_VIEW, 
            component: AddView, 
            ...childrenGuards, 
          }, 


          // vue de démarrage pour chargement du contexte (home)
          { 
            path: RouteEngine.INIT_VIEW, 
            component: InitView, 
            ...childrenGuards, 
          }, 
          { 
            path: RouteEngine.THUMB_VIEW, 
            component: ThumbView, 
            ...childrenGuards, 
          }, 
          // { path: '', redirectTo: RouteEngine.DASHBOARD_DATA_VIEW, pathMatch: 'full' },
          { 
            path: '', 
            redirectTo: RouteEngine.ADD_VIEW, 
            pathMatch: 'full'
          },
          // vue liste
          { 
            path: RouteEngine.LIST_VIEW, 
            component: ListView, 
            ...childrenGuards, 
          }, 
          // vue logs
          { 
            path: RouteEngine.LOG_VIEW, 
            component: LogView, 
            ...childrenGuards, 
          }, 
          // vue mitraillette
          { 
            path: RouteEngine.GATLING_VIEW, 
            component: GatlingView, 
            ...childrenGuards, 
          }, 
        ],
      },
      {
        label: '$.fallback.title.$',
        path: `${RouteEngine.FALLBACK_VIEW}`,
        component: FallbackView,
        canActivate: [AuthGuard],
      },
      { 
        path: '**', 
        redirectTo: RouteEngine.INIT_VIEW, 
        pathMatch: 'full'
      },
    ];

    return routes;
  }
}
